import { AuthoriseOauthWalletRequestBody } from "@syla/shared/types/requests/AuthoriseOauthWalletRequestBody";
import axios from "axios";
import { throwSylaApiError } from "../../api/errors/throwSylaApiError";
import { queryClient } from "../transactionsStore";
import { getWalletsQueryCacheKey } from "./wallet";

export const authoriseOauthWallet = async (
  accountId: string,
  props: AuthoriseOauthWalletRequestBody,
): Promise<void> => {
  try {
    await axios.post(
      `/accounts/${accountId}/wallets/authorise-oauth-wallet`,
      props,
    );
  } catch (error) {
    throwSylaApiError(error);
  } finally {
    queryClient.invalidateQueries([...getWalletsQueryCacheKey(accountId)]);
  }
};
